import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useBooking } from "./BookingContext";

const LINKS = [["about", "About"], ["offerings", "Offerings"], ["coming-soon", "Coming Soon"], ["faq", "FAQ"], ["contact", "Contact"]];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { openBooking } = useBooking();
  return (
    <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#FBFBF8]/75 border-b border-[#E6E0D4]/70">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <a key={id} href={`/#${id}`} data-testid={`nav-link-${id}`} className="link-underline text-sm text-[#2D2A26]">{label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="nav-book-now-button" onClick={() => openBooking()} className="btn-pill whitespace-nowrap bg-[#2D2A26] text-[#FBFBF8] hover:bg-[#A8613C] px-4 sm:px-5 py-2.5 text-sm">
            Book now
          </button>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#2D2A26]" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-[#E6E0D4] bg-[#FBFBF8] px-5 py-6 flex flex-col gap-5">
          {LINKS.map(([id, label]) => (
            <a key={id} href={`/#${id}`} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${id}`} className="font-display text-3xl text-[#2D2A26]">{label}</a>
          ))}
        </nav>
      )}
    </header>
  );
};
